/** @file Thai catalog part of area E4 (W3-03), partial; replaced whole by that area. */

/** The `curves` block (the Curves tab of the Timeline panel); partial, English fills the gaps. S0 composes it into `th`. */
export const curvesTh = {
  tab: 'เส้นโค้ง', graph: 'กราฟเส้นโค้ง', toolbar: 'เครื่องมือเส้นโค้ง',
  empty: 'เลือก key, bone หรือ slot ของ animation ปัจจุบันเพื่อดูเส้นโค้ง',
  preset: {
    linear: 'เส้นตรง', stepped: 'กระโดด', ease: 'นุ่มนวล', easeIn: 'เริ่มช้า', easeOut: 'จบช้า', easeInOut: 'เริ่มและจบช้า',
    backIn: 'ถอยก่อนพุ่ง', backOut: 'เลยแล้วเด้งกลับ',
  },
  copyShape: 'คัดลอกรูปทรงไปยัง key ที่เลือก', copyShapeFlat: 'ช่วงนี้ค่าไม่เปลี่ยน จึงไม่มีรูปทรงให้คัดลอก',
  normalize: 'ปรับสเกลให้เท่ากัน', showValues: 'แสดงค่าจริง', frameAll: 'แสดงทั้งหมด',
} as const;
